import React, { useState } from "react";
import { Card, Carousel, Container } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./actividadPages.css";
import "./arteActividad.css";

import imgArte1 from "../../../assets/images/arte1.jpg";
import imgArte2 from "../../../assets/images/arte2.jpg";
import imgArte3 from "../../../assets/images/arte3.jpg";
import imgArte4 from "../../../assets/images/arte4.jpg";
 
import imgMG0216 from "../../../assets/images/_MG_0216.jpg";
import imgMG0237 from "../../../assets/images/_MG_0237.jpg";
import imgMG0320 from "../../../assets/images/_MG_0320.jpg";
import imgMG0597 from "../../../assets/images/_MG_0597.jpg";
import imgMG0599 from "../../../assets/images/_MG_0599.jpg";
import imgMG0638 from "../../../assets/images/_MG_0638.jpg";
import imgMG0745 from "../../../assets/images/_MG_0745.jpg";
import imgMG0757 from "../../../assets/images/_MG_0757.jpg";
import imgMG1275 from "../../../assets/images/_MG_1275.jpg";
import imgMG1624 from "../../../assets/images/_MG_1624.jpg";
import MenuInteremedio from "./actividades/menuInteremedioActividades";

const images = [imgArte1, imgArte2, imgArte3, imgArte4];

const mgImages = [
 
  { src: imgMG0216, title: "Creación en clase" },
  { src: imgMG0237, title: "Arte compartido" },
  { src: imgMG0320, title: "Producciones escolares" },
  { src: imgMG0597, title: "Escena y movimiento" },
  { src: imgMG0599, title: "Trabajo creativo" },
  { src: imgMG0638, title: "Lenguajes artísticos" },
  { src: imgMG0745, title: "Teatro y expresión" },
  { src: imgMG0757, title: "Muestra artística" },
  { src: imgMG1275, title: "Encuentro creativo" },
  { src: imgMG1624, title: "Arte en comunidad" },
];

function ArteArrow({ className, onClick, direction }) {
  return (
    <button
      type="button"
      className={`${className || ""} arte-hero-arrow arte-hero-arrow--${direction}`}
      onClick={onClick}
      aria-label={direction === "prev" ? "Imagen anterior" : "Imagen siguiente"}
    />
  );
}

function ActividadArte() {
  const [imagenAmpliada, setImagenAmpliada] = useState(null);

  const heroSettings = {
    autoplay: true,
    autoplaySpeed: 4200,
    dots: true,
    infinite: true,
    speed: 750,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
    nextArrow: <ArteArrow direction="next" />,
    prevArrow: <ArteArrow direction="prev" />,
  };

  return (
    <div className="pb-5 arte-page">
      <section className="arte-hero" aria-label="Música, Plástica y Teatro">
        <Slider {...heroSettings}>
          {mgImages.slice(0, 7).map((image) => (
            <div key={image.title}>
              <article className="arte-hero-slide">
                <img src={image.src} alt={image.title} loading="lazy" />
                <div className="arte-hero-overlay" />
                <div className="arte-hero-content">
                  <span>Educación artística</span>
                  <h1>Música, Plástica y Teatro</h1>
                  <p>Espacios creativos donde nuestros estudiantes desarrollan su expresión artística.</p>
                </div>
              </article>
            </div>
          ))}
        </Slider>
      </section>

      <div className="activity-menu-shell arte-menu-top">
        <MenuInteremedio />
      </div>

      <Container className="arte-gallery-wrap">
        <div className="arte-section-heading">
          <span>Galería institucional</span>
          <h2>Arte en movimiento</h2>
          <p>Momentos de exploración, creación y encuentro a través de distintos lenguajes artísticos.</p>
        </div>
        <div className="arte-gallery">
          {mgImages.map((image) => (
            <button
              type="button"
              className="arte-gallery-card"
              key={image.title}
              onClick={() => setImagenAmpliada(image)}
              aria-label={`Ampliar imagen: ${image.title}`}
            >
              <img src={image.src} alt={image.title} loading="lazy" />
              <span>{image.title}</span>
            </button>
          ))}
        </div>
      </Container>

      {/* Encabezado */}
      <Card className="text-center arte-current-header">
        <Card.Body style={{ backgroundSize: "cover" }}>
          <Card.Text className="fw-bold fs-2">
            Música, Plástica y Teatro
          </Card.Text>
        </Card.Body>
      </Card>

      {/* Carrusel */}
      <Container className="my-4">
        <Carousel fade className="rounded shadow-lg overflow-hidden arte-current-carousel">
          {images.map((img, idx) => (
            <Carousel.Item key={idx}>
              <img
                className="d-block w-100"
                src={img}
                alt={`arte-${idx}`}
                loading="lazy"
                style={{ height: "500px", objectFit: "cover" }}
              />
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>

      {/* Descripción del proyecto artístico */}
      <Container className="p-5 my-5 rounded shadow-lg arte-description" style={{ backgroundColor: "#294235" }}>
        <h2 className="text-white text-center mb-4 fw-bold" style={{ letterSpacing: "1px" }}>
          EL ARTE EN NUESTRO COLEGIO
        </h2>
        <p className="lead text-white fs-5" style={{ lineHeight: "1.8" }}>
          En el Colegio Santo Tomás, el arte es una herramienta esencial para el desarrollo emocional,
          cognitivo y social de nuestros estudiantes. A través de disciplinas como la música, la pintura,
          el dibujo y el teatro, fomentamos la creatividad, la expresión personal y la sensibilidad estética.
        </p>
        <p className="text-white fs-5" style={{ lineHeight: "1.8" }}>
          Creemos que el arte permite explorar nuevas formas de comunicación, favorece la autoestima y
          fortalece los lazos sociales. Nuestras clases promueven la libertad de expresión, el respeto por
          la diversidad y el trabajo en equipo.
        </p>
        <p className="text-white fs-5" style={{ lineHeight: "1.8" }}>
          Nuestro proyecto artístico busca despertar el pensamiento crítico, el disfrute por el proceso
          creativo y el interés por las distintas manifestaciones culturales. Acompañamos a cada alumno
          en su recorrido, respetando su ritmo, estilo e identidad.
        </p>
        <p className="text-white fs-5" style={{ lineHeight: "1.8" }}>
          El arte en Santo Tomás es un espacio para imaginar, transformar y construir un mundo más sensible
          y humano.
        </p>
      </Container>

      {imagenAmpliada && (
        <div
          className="arte-lightbox"
          role="dialog"
          aria-modal="true"
          aria-label={`Imagen ampliada: ${imagenAmpliada.title}`}
          onClick={() => setImagenAmpliada(null)}
        >
          <div className="arte-lightbox-content" onClick={(event) => event.stopPropagation()}>
            <button
              type="button"
              className="arte-lightbox-close"
              onClick={() => setImagenAmpliada(null)}
              aria-label="Cerrar imagen ampliada"
            >
              ×
            </button>
            <img src={imagenAmpliada.src} alt={imagenAmpliada.title} />
            <h2>{imagenAmpliada.title}</h2>
          </div>
        </div>
      )}
    </div>
  );
}

export default ActividadArte;
